import type { Message } from '@/modules/chatting/types'
import { classNames } from '@/utils/helpers'

interface Props {
  message: Message
}

export const PriceTag = ({ message }: Props) => {
  return (
    <p
      className={classNames(
        'whitespace-nowrap rounded-2xl px-3 py-2 text-right text-xs font-medium leading-[18px] text-white',
        {
          'bg-success-default': message.isOpened,
          'bg-danger-default': !message.isOpened,
        },
      )}
    >
      ${message.price} - {message.isOpened ? 'paid' : 'not paid yet'}
    </p>
  )
}
